import { useState, type FormEvent } from "react";

type Mode = "login" | "register";

export function AuthGate({ onAuthenticated }: { onAuthenticated: () => Promise<void> }) {
  const [mode, setMode] = useState<Mode>("register");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (mode === "register" && password !== confirmation) return setError("两次输入的密码不一致");
    setBusy(true);
    setError("");
    try {
      const response = await fetch(`/api/auth/${mode}`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(mode === "register" ? { username, email, password } : { account, password }),
      });
      const payload = await response.json() as { error?: string };
      if (!response.ok) throw new Error(payload.error ?? "账号操作失败");
      await onAuthenticated();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "暂时无法连接服务器");
    } finally {
      setBusy(false);
    }
  };

  return <div className="auth-gate">
    <div className="auth-card">
      <div className="auth-visual"><span className="brand-mark">⌂</span><small>HARBOR RESIDENT ACCESS</small><h1>晴湾镇居民入口</h1><p>注册居民账号后，你的数字分身、住宅、家具、状态和生活经历都会持续保存在服务器。</p><div><b>此时此刻</b><span>游戏时间与现实同步，昼夜随行</span></div></div>
      <form onSubmit={submit}>
        <nav><button type="button" className={mode === "register" ? "active" : ""} onClick={() => { setMode("register"); setError(""); }}>注册新居民</button><button type="button" className={mode === "login" ? "active" : ""} onClick={() => { setMode("login"); setError(""); }}>登录已有账号</button></nav>
        <div className="auth-form-title"><span className="eyebrow">RESIDENT ACCOUNT</span><h2>{mode === "register" ? "创建居民账号" : "欢迎回到晴湾镇"}</h2><p>{mode === "register" ? "注册完成后继续创建人物姓名、性格、职业等角色档案。" : "使用账号或邮箱恢复你的全部生活存档。"}</p></div>
        {mode === "register" ? <>
          <label>登录账号<input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} placeholder="3—24位字母、数字或下划线" /></label>
          <label>邮箱 <em>选填</em><input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="用于未来账号恢复" /></label>
        </> : <label>账号或邮箱<input autoComplete="username" value={account} onChange={(event) => setAccount(event.target.value)} placeholder="输入登录账号或邮箱" /></label>}
        <label>密码<input type="password" autoComplete={mode === "register" ? "new-password" : "current-password"} value={password} onChange={(event) => setPassword(event.target.value)} placeholder={mode === "register" ? "至少10个字符" : "输入密码"} /></label>
        {mode === "register" && <label>确认密码<input type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} placeholder="再次输入密码" /></label>}
        {error && <div className="auth-error">{error}</div>}
        <button className="auth-submit" disabled={busy}>{busy ? "正在连接…" : mode === "register" ? "注册并创建数字分身" : "登录晴湾镇"}</button>
        <small>密码仅以不可逆加密结果保存在服务器</small>
      </form>
    </div>
  </div>;
}
